// gnav
function gnav() {
  $('.js-header__btn, .js-headerNav__close').click(function() {
    $('.js-header').toggleClass('is-active');
  });
}

// back to top
function fadeInBackToTopBtn() {
  var timeout;
  var $window = $(window);
  var $btn = $('.back-toTop');

  $window.on('scroll', function(e){
    clearTimeout(timeout);

    timeout = setTimeout(function(){
      var scroll = $(window).scrollTop() + $(window).height();
      var scrollEnd = $('.footer').offset().top;

      if ($window.scrollTop() > 200) {
        $btn.addClass('show');
      } if (scroll > scrollEnd){
        $btn.removeClass('show');
      }
    }, 100);
  });
}

// smooth-scroll
function backToTop() {
  $('.back-toTop').click(function () {
    $("html, body").animate({scrollTop: 0}, 1000);
  });
}

// set cookie to browser
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

// get cookie from browser
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return "";
}

function closeShopBanner() {
  $('.fixed-banner__btn').click(function() {
    $(this).parents('.fixed-banner').removeClass('show');
    setCookie('top-banner', 'true', 1);
  });
}

function fadeInShopBanner() {
  var timeout;
  var $window = $(window);
  var $banner = $('.fixed-banner');
  
  $window.on('scroll', function(e){
    var scroll = $(window).scrollTop() + $(window).height();
    var scrollEnd = $('.footer').offset().top;

    clearTimeout(timeout);
    timeout = setTimeout(function(){
      if ($window.scrollTop() > 150) {
        var cookie = getCookie('top-banner');
        if (!cookie) {
          $banner.addClass('show');
        }
      } if (scroll > scrollEnd){
        $banner.removeClass('show');
      }
    }, 100);
  });
}

function getInstagram() {
  $.ajax({
		type: 'GET',
		url: 'https://graph.facebook.com/v17.0/17841443080277977?fields=name%2Cmedia.limit(7)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAAGAqz2lSmUBABZCWnt5MgjaX3kmuxK8YvDGuwZCXw30UZCzZBoZAMofxfyAzu1UZAbZA0k97OIIlfdf5egt1Nh0wjivCt241XQH1z8OYvolYepAZAc792YPxTxz3tq6A5UzZAZCNFEcXwOGXAWrICIw239uZAD6gKjElGeva0dRQx0FyglvZAjBKUDgSBq8IvvtV9AZD',
		dataType: 'json',
		success: function(json) {
      var html = '';
      var insta = json.media.data;
      
      insta.forEach(item => {
        if (item.media_url.indexOf('video') !== -1){
          html += 
            `<li class="instagram__item">
              <a href="${item.permalink}" class="instagram__link" target="_blank">
                <video src="${item.media_url}" autoplay muted playsinline>
                  <source src="${item.media_url}">
                </video>
              </a>
            </li>`;
        }else{
          html += 
            `<li class="instagram__item">
              <a href="${item.permalink}" class="instagram__link" target="_blank">
                <img src="${item.media_url}">
              </a>
            </li>`;
        }
      });
      $(".instagram__list").append(html);
		},
		error: function() {
      $(".instagram__list").hide();
		}
	});
}

function switchLang() {
  $('.gnav__lang-change li a').click(function () {
    var lang = $(this).attr('data-src');
    $('.js-activeLang').text(lang);
  });
}

gnav();
fadeInBackToTopBtn();
backToTop();
objectFitImages();
closeShopBanner();
switchLang();